var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.99989L7.46967 2.03022C7.76256 1.73732 8.23744 1.73732 8.53033 2.03022L14.5 7.99989M3 6.49989V13.2499C3 13.6641 3.33579 13.9999 3.75 13.9999H6.5V10.7499C6.5 10.3357 6.83579 9.99989 7.25 9.99989H8.75C9.16421 9.99989 9.5 10.3357 9.5 10.7499V13.9999H12.25C12.6642 13.9999 13 13.6641 13 13.2499V6.49989M5.5 13.9999H11",
    stroke: "#5F606D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.838defd700e29fc1abc8f7b0e6edaf17.svg";
export { ForwardRef as ReactComponent };